export default "__VITE_ASSET__paPp$mHv__"